// Backend analytics actions

export const NAVIGATOR_STARTED_ACTION = 'track_home_and_auto_navigator_started';
export const NAVIGATOR_COMPLETED_ACTION = 'track_home_and_auto_navigator_completed';
export const ACCOUNT_CREATED_ACTION = 'track_account_created';
export const CONTACT_INFO_CREATED_ACTION = 'track_home_and_auto_contact_info_completed';
export const ESTIMATES_VIEWED_ACTION = 'track_home_and_auto_estimates_viewed';

// Frontend analytics events

export const CLICKED_BUTTON = 'Clicked Button';
export const CLICKED_LINK = 'Clicked Link';
export const NAVIGATOR_STARTED = 'Started navigator';
export const NAVIGATOR_STEP_STARTED = 'Started navigator step';
export const NAVIGATOR_STEP_COMPLETED = 'Completed navigator step';
export const NAVIGATOR_COMPLETED = 'Completed navigator';
export const EXPERIMENT_VIEWED = 'Experiment Viewed';
